import React from 'react';
import { Split } from 'lucide-react';

const SignOut = () => {
  return (
    <div className="min-h-screen bg-primary/10 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-retro border-2 border-dark p-8 text-center">
        <Split className="h-16 w-16 text-primary mx-auto mb-6" />
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Sorry to see you go! 👋
        </h1>
        <p className="text-xl text-gray-600 mb-8">
          But when you're gone your doubles will still be hard at work. See you later ✌️
        </p>
        <a
          href="/"
          className="inline-block px-8 py-3 bg-primary text-white rounded-full hover:bg-primary/90 transition-colors font-medium"
        >
          Back to Home
        </a>
      </div>
    </div>
  );
};

export default SignOut;